import React, { useEffect } from "react";

const ConfigForTitle = ({ titleConfig, setTitleConfig, ordersData }) => {
  useEffect(() => {
    if (typeof ordersData !== "undefined") {
      setTitleConfig(
        JSON.stringify(ordersData["configs"]["title_configs"], null, 2)
      );
    } else {
      fetch("/title_config.json")
        .then((response) => response.text())
        .then((data) => setTitleConfig(data))
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, []);

  const handleChange = (e) => {
    setTitleConfig(e.target.value);
  };

  return (
    <div className="mt-10 shadow-lg bg-gray-100 rounded-lg pl-3 pb-3 pt-2">
      <div className="text-center font-bold pb-2">Config for Title</div>
      <textarea
        type="text"
        id="title-config"
        value={titleConfig}
        onChange={handleChange}
        placeholder="Enter the config for title generation...."
        style={{
          width: "280px",
          height: "175px",
          border: "1px solid black",
          borderRadius: "10px",
          padding: "5px",
        }}
      />
      <a
        href="https://platform.openai.com/docs/guides/text-generation/json-mode"
        target="_blank"
        rel="noopener noreferrer"
        class="text-blue-500 hover:underline"
      >
        ** Click here for documentation
      </a>
    </div>
  );
};

export default ConfigForTitle;
